module.exports = __webpack_public_path__ + "img/undraw_questions-small.95148179.webp";